export const disciplines = [
  { name: 'Rhythm', path: 'rhythm', color: '#5259bc', ink: '#fff8ec' },
  { name: 'Rhyme', path: 'rhyme', color: '#c23737', ink: '#fff8ec' },
  { name: 'Rhetoric', path: 'rhetoric', color: '#f5de48', ink: '#251e11' },
  { name: 'Delivery', path: 'delivery', color: '#6ba971', ink: '#17251a' },
]

export function DisciplineSymbol({ discipline, className }) {
  return (
    <svg viewBox="0 0 80 80" className={className} fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {discipline === 'rhythm' && <>
        <path d="M12 34v12M26 22v36M40 12v56M54 22v36M68 34v12" strokeWidth="7" />
      </>}
      {discipline === 'rhyme' && <>
        <path d="M12 24h22v22H22l-8 12M46 24h22v22H56l-8 12" />
        <path d="M22 34h2M56 34h2" strokeWidth="6" />
      </>}
      {discipline === 'rhetoric' && <>
        <path d="M63 49a27 27 0 1 0-42 7l-2 13 14-9a27 27 0 0 0 30-11Z" />
        <path d="m40 20 3 9 9 3-9 3-3 9-3-9-9-3 9-3Z" strokeWidth="3" />
      </>}
      {discipline === 'delivery' && <>
        <rect x="30" y="11" width="20" height="38" rx="10" />
        <path d="M21 37v4a19 19 0 0 0 38 0v-4M40 60v10M30 70h20M36 23h8M36 31h8" />
      </>}
    </svg>
  )
}
